import React, { ReactElement, useEffect, useState } from "react";
import StvPage from "./ctx-provider/StvPage";
import WizardPage from '../ui/page/wizard/WizardPage';
import SessionInvalidPage from "../ui/page/error/SessionInvalidPage";
import useAppCtx from "./ctx-provider/useAppCtx";
import Homepage from "../ui/page/homepage/Homepage";
import ErrorPage from "../ui/page/error/ErrorPage";
import HomepageFacelift from "../ui/page/homepage_facelift/HomepageFacelift";
import HomepageDogorama from "../ui/page/homepage_dogorama/HomepageDogorama";

const CONTENT_MAP = new Map<StvPage, ReactElement>();
CONTENT_MAP.set(StvPage.WIZARD, <WizardPage />);
CONTENT_MAP.set(StvPage.SESSION_INVALID, <SessionInvalidPage />);
CONTENT_MAP.set(StvPage.HOMEPAGE, <Homepage />);
CONTENT_MAP.set(StvPage.ERROR, <ErrorPage />);
CONTENT_MAP.set(StvPage.HOMEPAGE_FACELIFT, <HomepageFacelift />);
CONTENT_MAP.set(StvPage.HOMEPAGE_DOGORAMA, <HomepageDogorama />);


// Der Inhalt wird bestimmt
const getContent = (page: StvPage) => {
    return CONTENT_MAP.has(page) ? CONTENT_MAP.get(page) : undefined;
}

const useAppContent = () => {
    const [content, setContent] = useState<JSX.Element>();
    const { appCtxBo } = useAppCtx();
    const currentPage = appCtxBo.currentPage;

    useEffect(() => {
        const newContent = getContent(currentPage);

        if (newContent) {
            setContent(newContent);
        }

    }, [currentPage]);

    return { content };
};

export default useAppContent;